import { Outlet } from 'react-router-dom';

/**
 * Enveloppe de l'espace Déploiement (front repris du projet recube-cicd).
 *
 * La classe `.deploy-scope` (cf. styles/global.scss) redéfinit localement la palette
 * sémantique "vive + translucide" attendue par les composants du front repris, SANS
 * impacter le reste du panel. L'accent principal (--color-primary) reste celui du jeu
 * actif, posé par AdminLayout.
 *
 * Les contrôles de l'espace (⚙ nav secondaire + « Sortir ») sont désormais dans la
 * navbar du panel (cf. DeployHeaderControls) ; le bouton « Déployer » est dans la
 * sidebar (cf. Sidebar). Ici on ne garde que le wrapper de scope + l'Outlet.
 */
export function DeployScope() {
  return (
    <div className="deploy-scope">
      <Outlet />
    </div>
  );
}
